import { Link } from 'react-router-dom';
import { ArrowRight, Phone } from 'lucide-react';
import { SITE } from '../data/site';

// Renders content blocks ({t:'h2'|'h3'|'p'|'list'}) with [text](/path) inline links.
const Inline = ({ text }) => {
  const parts = text.split(/(\[[^\]]+\]\([^)]+\))/g);
  return (
    <>
      {parts.map((part, i) => {
        const m = part.match(/^\[([^\]]+)\]\(([^)]+)\)$/);
        if (m) {
          return (
            <Link key={i} to={m[2]} className="font-semibold text-bronze underline decoration-bronze/40 underline-offset-4 transition-colors hover:text-ink">
              {m[1]}
            </Link>
          );
        }
        return <span key={i}>{part}</span>;
      })}
    </>
  );
};

const RichText = ({ blocks }) => (
  <div data-testid="rich-text" className="space-y-6">
    {blocks.map((b, i) => {
      if (b.t === 'h2') return <h2 key={i} className="pt-4 font-serif text-3xl font-medium tracking-tight text-ink">{b.text}</h2>;
      if (b.t === 'h3') return <h3 key={i} className="pt-2 font-serif text-2xl font-medium tracking-tight text-ink">{b.text}</h3>;
      if (b.t === 'cta') {
        return (
          <div key={i} data-testid={`article-cta-${i}`} className="border border-line bg-paper2/60 px-6 py-7 md:px-8">
            <p className="font-serif text-2xl font-medium tracking-tight text-ink">{b.title || 'Ready to talk through your project?'}</p>
            {b.text && <p className="mt-2 max-w-xl text-sm leading-relaxed text-muted2"><Inline text={b.text} /></p>}
            <div className="mt-5 flex flex-wrap items-center gap-3">
              <Link to="/get-a-quote/" className="btn-primary !px-5 !py-3 !text-xs">Get a Free Quote</Link>
              <a href={SITE.phoneHref} className="inline-flex items-center gap-2 text-sm font-semibold text-bronze transition-colors hover:text-ink">
                <Phone className="h-4 w-4" /> Call {SITE.phone}
              </a>
            </div>
          </div>
        );
      }
      if (b.t === 'list') {
        return (
          <ul key={i} className="space-y-3">
            {b.items.map((item, j) => (
              <li key={j} className="flex gap-3 text-base leading-relaxed text-muted2">
                <span className="mt-2.5 h-1.5 w-1.5 shrink-0 rotate-45 bg-bronze" aria-hidden="true" />
                <span><Inline text={item} /></span>
              </li>
            ))}
          </ul>
        );
      }
      return <p key={i} className="text-base leading-relaxed text-muted2 md:text-lg"><Inline text={b.text} /></p>;
    })}
  </div>
);

export default RichText;
